import axios from 'axios';
// import handleStatus from '@/plugins/axios/axios.handleStatus.js';
// import store from '@/store/index'
// import router from '@/router/index.js'
// import { Message, Notification } from 'element-ui'

/**
 * 默认配置
 */
console.log('axios-process.env:', process.env);
console.log('process.env.VUE_APP_BASEURL:', process.env.VUE_APP_BASEURL);
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
axios.defaults.timeout = 10000;

/**
 * 请求拦截
 */
const requestInterceptors = axios.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // config.headers.common['cookie-id'] = cookieId
    return config;
  },
  (err) => {
    // 对请求错误做些什么
    Promise.reject(err);
  }
);
/**
 * 响应拦截
 */
const responseInterceptors = axios.interceptors.response.use(
  (response) => {
    // return Promise.resolve(handleStatus(response));
    return Promise.resolve(response);
  },
  // 对响应错误做点什么
  (err) => {
    console.log('响应错误拦截err:', err);
    // 错误信息err传入isCancel方法，可以判断请求是否被取消
    if (axios.isCancel(err)) {
      throw new axios.Cancel('cancel request');
    } else {
      console.log('网络请求失败，请重试:');
    }
    return Promise.reject(err);
  }
);

// 移除请求拦截器
function removeRequestInterceptors() {
  axios.interceptors.request.eject(requestInterceptors);
}

// 移除响应拦截器
function removeResponseInterceptors() {
  axios.interceptors.response.eject(responseInterceptors);
}

axios.removeRequestInterceptors = removeRequestInterceptors;
axios.removeResponseInterceptors = removeResponseInterceptors;

export default axios;
